import { ButtonHoc } from '../Helpers/ButtonHoc';
var PrimaryButton = ButtonHoc({
  rippleColor: 'bgTargetPrimary',
  textColorDefault: 'textCTAPrimary',
  textColorDisabled: 'textCTAPrimaryDisabled',
  bgColorDefault: 'bgCTAPrimary',
  bgColorHover: 'bgHoverPrimary',
  bgColorDisabled: 'bgCTAPrimaryDisabled',
  loaderColor: 'textActionTertiary',
  shadowType: 'shadow8Button'
});
export default PrimaryButton;